<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="人员" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="职位" min-width="100" prop="zhiwei"></el-table-column>
          
          <el-table-column align="center" label="客户" min-width="100" prop="kehu"></el-table-column>
          <el-table-column align="center" label="订单号" min-width="100" prop="dingdanhao"></el-table-column>
          <el-table-column align="center" label="货号" min-width="100" prop="huohao"></el-table-column>
          <el-table-column align="center" label="产品规格" min-width="100" prop="chanpinguige"></el-table-column>
          <el-table-column align="center" label="颜色" min-width="100" prop="yanse"></el-table-column>
          
          <el-table-column align="center" label="物料名称" min-width="100" prop="wuliaomingcheng"></el-table-column>
          <el-table-column align="center" label="物料规格" min-width="100" prop="wuliaoguige"></el-table-column>
          <el-table-column align="center" label="材质" min-width="100" prop="caizhi"></el-table-column>
          <el-table-column align="center" label="单根工价普工" min-width="100" prop="danjiapugong"></el-table-column>
          <el-table-column align="center" label="单根工价枪手" min-width="100" prop="danjiaqiangshou"></el-table-column>
          <el-table-column align="center" label="普工产量" min-width="100" prop="chanliangpugong"></el-table-column>
          <el-table-column align="center" label="枪手产量" min-width="100" prop="chanliangqiangshou"></el-table-column>
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="date" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="人员" prop="renyuan">
          <div style="display: flex;">
            <el-input v-model="editForm.renyuan" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.renyuan" filterable placeholder="请选择" style="width: 400px;">
              <el-option v-for="(item,index) in memberSelectList"
                :key="index" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="职位" prop="zhiwei">
          <div style="display: flex;">
            <el-input v-model="editForm.zhiwei" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.zhiwei" filterable placeholder="请选择" style="width: 400px;">
              <el-option v-for="(item,index) in zhiweiSelectList"
                :key="index" :label="item.zhiwei" :value="item.zhiwei">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="客户" prop="kehu">
          <el-select v-model="orderValue" filterable placeholder="请选择"
            @change="orderChange" style="width: 600px;">
            <el-option v-for="item in orderSelectList"
              :key="item.kehu+'_'+item.dingdanhao+'_'+item.huohao+'_'+item.chanpinguige+'_'+item.yanse"
              :label="item.kehu+'_'+item.dingdanhao+'_'+item.huohao+'_'+item.chanpinguige+'_'+item.yanse"
              :value="item.kehu+'_'+item.dingdanhao+'_'+item.huohao+'_'+item.chanpinguige+'_'+item.yanse">
            </el-option>
          </el-select>
          <el-input v-model="editForm.kehu" style="margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item label="订单号" prop="dingdanhao">
          <el-input v-model="editForm.dingdanhao"></el-input>
        </el-form-item>
        <el-form-item label="货号" prop="huohao">
          <el-input v-model="editForm.huohao"></el-input>
        </el-form-item>
        <el-form-item label="产品规格" prop="chanpinguige">
          <el-input v-model="editForm.chanpinguige"></el-input>
        </el-form-item>
        <el-form-item label="颜色" prop="yanse">
          <el-input v-model="editForm.yanse"></el-input>
        </el-form-item>
        <el-form-item label="物料名称" prop="wuliaomingcheng">
          <div style="display: flex;">
            <el-input v-model="editForm.wuliaomingcheng" style="margin-right: 10px;"></el-input>
            <el-select v-model="gongxuValue" filterable placeholder="请选择" style="width: 400px;"
              @change="gongxuChange" >
              <el-option v-for="(item,index) in gongxuSelectList"
                :key="index" :label="item.wuliaomingcheng" 
                :value="item.wuliaomingcheng">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="物料规格" prop="wuliaoguige">
          <el-input v-model="editForm.wuliaoguige"></el-input>
        </el-form-item>
        <el-form-item label="材质" prop="caizhi">
          <el-input v-model="editForm.caizhi"></el-input>
        </el-form-item>
        <el-form-item label="单根工价普工" prop="danjiapugong">
          <el-input-number v-model="editForm.danjiapugong" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="单根工价枪手" prop="danjiaqiangshou">
          <el-input-number v-model="editForm.danjiaqiangshou" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="普工产量" prop="chanliangpugong">
          <el-input-number v-model="editForm.chanliangpugong" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="枪手产量" prop="chanliangqiangshou">
          <el-input-number v-model="editForm.chanliangqiangshou" :precision="5" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    riqi: '',
    renyuan: "",
    zhiwei: "",
    
    kehu: "",
    dingdanhao: "",
    huohao: "",
    chanpinguige: "",
    dingdanshuliang: 0,
    yanse: "",
    xuhao: "",
    
    wuliaomingcheng: "",
    wuliaoguige: "",
    caizhi: "",
    
    danjiapugong: 0,
    danjiaqiangshou: 0,
    chanliangpugong: 0,
    chanliangqiangshou: 0,
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      orderSelectList: [],
      memberSelectList: [],
      gongxuSelectList: [],
      zhiweiSelectList: [],
      orderValue: '',
      gongxuValue: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
    this.getSelectList()
    this.getMemberSelectList()
    this.getZhiweiSelectList()
  },

  methods: {
    orderChange(e) {
      let arr = e.split('_')
      for(let i in this.orderSelectList) {
        if(this.orderSelectList[i].kehu==arr[0]&&
        this.orderSelectList[i].dingdanhao==arr[1]&&
        this.orderSelectList[i].huohao==arr[2]&&
        this.orderSelectList[i].chanpinguige==arr[3]&&
        this.orderSelectList[i].yanse==arr[4]) {
          this.editForm.kehu = this.orderSelectList[i].kehu;
          this.editForm.dingdanhao = this.orderSelectList[i].dingdanhao;
          this.editForm.huohao = this.orderSelectList[i].huohao;
          this.editForm.chanpinguige = this.orderSelectList[i].chanpinguige;
          this.editForm.dingdanshuliang = this.orderSelectList[i].dingdanshuliang;
          this.editForm.yanse = this.orderSelectList[i].yanse;
          
          this.gongxuValue = ''
          this.editForm.wuliaomingcheng = '';
          this.editForm.wuliaoguige = '';
          this.editForm.caizhi = '';
          this.editForm.dansanyongliang = 0;
          this.editForm.danjiapugong = 0;
          this.editForm.danjiaqiangshou = 0;
          
          if(this.orderSelectList[i].gongxuArr) {
            this.gongxuSelectList = JSON.parse(this.orderSelectList[i].gongxuArr)
          }else{
            this.gongxuSelectList = []
          }
        }
      }
    },
    
    gongxuChange(e) {
      for(let i in this.gongxuSelectList) {
        if(this.gongxuSelectList[i].wuliaomingcheng==e) {
          this.editForm.wuliaomingcheng = this.gongxuSelectList[i].wuliaomingcheng;
          this.editForm.wuliaoguige = this.gongxuSelectList[i].wuliaoguige;
          this.editForm.caizhi = this.gongxuSelectList[i].caizhi;
          this.editForm.dansanyongliang = this.gongxuSelectList[i].dansanyongliang;
          this.editForm.danjiapugong = this.gongxuSelectList[i].danjiapugong;
          this.editForm.danjiaqiangshou = this.gongxuSelectList[i].danjiaqiangshou;
        }
      }
    },
    
    getSelectList() {
      this.$request.post('/index.php/admin/ordermodel/tuzhuangliangtingMbSelect').then((res) => {
        this.orderSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getMemberSelectList() {
      this.$request.post('/index.php/admin/admin/memberSelect').then((res) => {
        this.memberSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getZhiweiSelectList() {
      this.$request.post('/index.php/admin/admin/zhiweiSelect').then((res) => {
        this.zhiweiSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      if(form.renyuan) {
        this.editForm.renyuan = form.renyuan
      }
      if(form.zhiwei) {
        this.editForm.zhiwei = form.zhiwei
      }
      if(form.kehu) {
        this.editForm.kehu = form.kehu;
        this.editForm.dingdanhao = form.dingdanhao;
        this.editForm.huohao = form.huohao;
        this.editForm.chanpinguige = form.chanpinguige;
        this.editForm.dingdanshuliang = form.dingdanshuliang;
        this.editForm.yanse = form.yanse;
      }
      if(form.wuliaomingcheng) {
        this.editForm.wuliaomingcheng = form.wuliaomingcheng;
        this.editForm.wuliaoguige = form.wuliaoguige;
        this.editForm.caizhi = form.caizhi;
        this.editForm.dansanyongliang = form.dansanyongliang;
        this.editForm.danjiapugong = form.danjiapugong;
        this.editForm.danjiaqiangshou = form.danjiaqiangshou;
      }
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/gongzi/tzltgzInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/gongzi/tzltgzDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/gongzi/tzltgzSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      this.$request.post('/index.php/admin/gongzi/tzltgzList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
